import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "src/app/shared/shared.module";

import { NotasCadastroComponent } from "./cadastro/notas-cadastro.component";
import { NotasRoutingModule } from "./notas-routing.module";
import { NotasListagemComponent } from "./pesquisa/listagem/notas-listagem.component";
import { NotasPesquisaComponent } from "./pesquisa/notas-pesquisa.component";

@NgModule({
    imports:[
        SharedModule,
        NotasRoutingModule,
    ],
    declarations: [
        NotasCadastroComponent,
        NotasPesquisaComponent,
        NotasListagemComponent
    ],
    exports:[NotasListagemComponent],
    providers:[
        ReactiveFormsModule,
        FormsModule,
        CommonModule,
    ]
})
export class NotasModule{}